import { TableStructure } from "../components/TableStructure";
import { CHVSDeptLeftMenuList } from "../utils/constants";

const List = [
  {
    fileStoreId: "18022626-2a59-4f3c-8a94-891f18042026",
    label: "Development Fees Application Form",
  },
  {
    fileStoreId: "18022526-2a59-4f3c-8a94-891f18042026",
    label: "Survey Observation Report (SOR) Application Form",
  },
];

const CH_VS_Dept_Download_Forms = () => (
  <TableStructure
    title="Download Forms"
    heading={"List of Forms"}
    list={List}
    columnNo={1}
    leftMenuList={CHVSDeptLeftMenuList}
    longMenuList={false}
  />
);

export default CH_VS_Dept_Download_Forms;
